// // import React, { useEffect, useState } from "react";
// // import axios from "../../api/axiosInstance";
// // import toast from "react-hot-toast";
// // import dayjs from "dayjs";
// // import { Link, useNavigate } from "react-router-dom";
// // import GlobalLoader from "./GlobalLoader";
// // import FilterPillBar from "./FilterPillBar"; // adjust path
// // import { FaHeart, FaRegHeart } from "react-icons/fa";
// // import { FiMoreVertical } from "react-icons/fi";
// // import { confirmAlert } from "react-confirm-alert";
// // import "react-confirm-alert/src/react-confirm-alert.css";
// // import EmptyStateCentered from "../static/EmptyStateCentered";

// // const MatchesListPage = () => {
// //   const [matches, setMatches] = useState([]);
// //   const [favourites, setFavourites] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [activeFilters, setActiveFilters] = useState({});
// //   const [menuOpenId, setMenuOpenId] = useState(null);

// //   const user = JSON.parse(localStorage.getItem("user"));
// //   const navigate = useNavigate();
// //   const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

// //   const fetchMatches = async (filters = {}) => {
// //     try {
// //       setLoading(true);
// //       const res = await axios.get("api/matches/", {
// //         params: filters,
// //       });
// //       setMatches(res.data);
// //       setLoading(false);
// //     } catch (error) {
// //       console.error(error.response?.data || error.message);
// //       toast.error("Failed to fetch matches");
// //       setLoading(false);
// //     }
// //   };

// //   const fetchFavourites = async () => {
// //     try {
// //       const res = await axios.get("/api/favourites/", {
// //         headers: {
// //           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
// //         },
// //       });
// //       setFavourites(res.data.map((fav) => fav.favourite_user));
// //     } catch (error) {
// //       console.error(error.response?.data || error.message);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchMatches();
// //     fetchFavourites();
// //   }, []);

// //   const sendInterest = async (receiverId) => {
// //     try {
// //       await axios.post(
// //         "/api/interests/",
// //         { receiver: receiverId },
// //         {
// //           headers: {
// //             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
// //           },
// //         }
// //       );
// //       toast.success("Interest sent!");
// //     } catch (error) {
// //       console.error(error.response?.data || error.message);
// //       toast.error("Failed to send interest");
// //     }
// //   };

// //   const ignoreProfile = async (receiverId) => {
// //     try {
// //       await axios.post(
// //         "/api/interests/",
// //         { receiver: receiverId, status: "ignored" },
// //         {
// //           headers: {
// //             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
// //           },
// //         }
// //       );
// //       toast.success("Profile ignored!");
// //       setMatches((prev) => prev.filter((m) => m.user.id !== receiverId));
// //     } catch (error) {
// //       console.error(error.response?.data || error.message);
// //       toast.error("Failed to ignore profile");
// //     }
// //   };

// //   const toggleFavourite = async (receiverId) => {
// //     try {
// //       if (favourites.includes(receiverId)) {
// //         // Remove from favourites
// //         await axios.delete(`/api/favourites/${receiverId}/`, {
// //           headers: {
// //             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
// //           },
// //         });
// //         setFavourites((prev) => prev.filter((id) => id !== receiverId));
// //         toast.success("Removed from favourites!");
// //       } else {
// //         // Add to favourites
// //         await axios.post(
// //           "/api/favourites/",
// //           { favourite_user: receiverId },
// //           {
// //             headers: {
// //               Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
// //             },
// //           }
// //         );
// //         setFavourites((prev) => [...prev, receiverId]);
// //         toast.success("Added to favourites!");
// //       }
// //     } catch (error) {
// //       console.error(error.response?.data || error.message);
// //       toast.error("Failed to update favourite status");
// //     }
// //   };
// //   const handleBlockProfile = (receiverId) => {
// //     confirmAlert({
// //       title: "Confirm Block",
// //       message:
// //         "Are you sure you want to block this profile? You will not receive messages or see this profile again.",
// //       buttons: [
// //         {
// //           label: "Yes, Block",
// //           onClick: async () => {
// //             try {
// //               await axios.post(
// //                 "/api/block-profile/",
// //                 { blocked_id: receiverId },
// //                 {
// //                   headers: {
// //                     Authorization: `Bearer ${localStorage.getItem(
// //                       "accessToken"
// //                     )}`,
// //                   },
// //                 }
// //               );
// //               toast.success("Profile blocked successfully.");
// //               setMatches((prev) =>
// //                 prev.filter((m) => m.user.id !== receiverId)
// //               );
// //             } catch (error) {
// //               console.error(error.response?.data || error.message);
// //               toast.error("Failed to block profile.");
// //             }
// //           },
// //         },
// //         {
// //           label: "Cancel",
// //           className: "bg-gray-200 text-gray-700",
// //         },
// //       ],
// //       closeOnEscape: true,
// //       closeOnClickOutside: true,
// //       overlayClassName: "bg-black bg-opacity-50",
// //     });
// //   };

// //   if (loading) {
// //     return <GlobalLoader />;
// //   }

// //   return (
// //     <div className="p-4 w-full mx-auto overflow-y-auto pt-16 sm:pt-16">
// //       <FilterPillBar
// //         activeFilters={activeFilters}
// //         setActiveFilters={setActiveFilters}
// //         onFilterChange={(filters) => fetchMatches(filters)}
// //       />

// //       {matches.length === 0 ? (
// //         <p className="text-center text-gray-500 mt-10">
// //           {/* No matches available at the moment. */}
// //           <EmptyStateCentered />
// //         </p>
// //       ) : (
// //         <div className="flex flex-col gap-4">
// //           {matches.map((match) => (
// //             <div
// //               key={match.id}
// //               className="bg-white  w-full   rounded shadow p-4 flex flex-col sm:flex-row items-center sm:items-start gap-4 relative"
// //             >
// //               <Link
// //                 to={`/profile/${match.user.id}`}
// //                 className="flex-shrink-0 relative"
// //               >
// //                 {/* Diagonal Newly Joined Badge */}
// //                 {dayjs().diff(dayjs(match.created_at), "day") <= 30 && (
// //                   <div className="absolute top-0 left-0 bg-pink-600 text-white text-xs font-semibold px-2 py-0.5 rounded shadow">
// //                     NEW
// //                   </div>
// //                 )}
// //                 <img
// //                   src={
// //                     match.photo || require("../../assets/default_image.webp")
// //                   }
// //                   alt={`${match.user.first_name}`}
// //                   className="w-32 h-32 object-cover rounded"
// //                 />

// //                 {/* Heart button */}
// //                 <button
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     toggleFavourite(match.user.id);
// //                   }}
// //                   className="absolute top-2 right-2 bg-white p-1 rounded-full shadow hover:bg-gray-100"
// //                 >
// //                   {favourites.includes(match.user.id) ? (
// //                     <FaHeart className="text-pink-600" />
// //                   ) : (
// //                     <FaRegHeart className="text-gray-500" />
// //                   )}
// //                 </button>
// //               </Link>
// //               <div className="absolute top-2 right-2">
// //                 <button
// //                   onClick={(e) => {
// //                     e.stopPropagation();
// //                     setMenuOpenId(
// //                       menuOpenId === match.user.id ? null : match.user.id
// //                     );
// //                   }}
// //                   className="p-1 hover:bg-gray-100 rounded-full"
// //                 >
// //                   <FiMoreVertical size={18} />
// //                 </button>
// //                 {menuOpenId === match.user.id && (
// //                   <div className="absolute right-0 mt-2 w-40 bg-white border rounded shadow z-50">
// //                     <button
// //                       onClick={(e) => {
// //                         e.stopPropagation();
// //                         handleBlockProfile(match.user.id);
// //                         setMenuOpenId(null);
// //                       }}
// //                       className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
// //                     >
// //                       Block Profile
// //                     </button>
// //                   </div>
// //                 )}
// //               </div>

// //               <div className="flex-1">
// //                 <Link
// //                   to={`/profile/${match.user.id}`}
// //                   className="flex-shrink-0 text-decoration-none"
// //                 >
// //                   <p className="font-semibold text-lg">
// //                     {match.user.first_name} {match.user.last_name}
// //                   </p>
// //                   <p className="text-sm text-gray-600 mb-2">
// //                     {calculateAge(match.dob)} yrs • {match.height_feet}'
// //                     {match.height_inches}" • {match.religion} •{" "}
// //                     {match.marital_status} • {match.highest_education} •{" "}
// //                     {match.employed_in} • {match.city}
// //                   </p>
// //                 </Link>
// //                 <div className="flex gap-2 mt-4">
// //                   <button
// //                     onClick={() => ignoreProfile(match.user.id)}
// //                     className="border border-gray-300 text-gray-700 px-3 py-1 rounded hover:bg-gray-100 transition"
// //                   >
// //                     Don't Show
// //                   </button>
// //                   <button
// //                     onClick={() => sendInterest(match.user.id)}
// //                     className="bg-pink-600 text-white px-3 py-1 rounded hover:bg-pink-700 transition"
// //                   >
// //                     Send Interest
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default MatchesListPage;

// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosInstance";
// import toast from "react-hot-toast";
// import dayjs from "dayjs";
// import { Link, useNavigate } from "react-router-dom";
// import GlobalLoader from "./GlobalLoader";
// import FilterPillBar from "./FilterPillBar";
// import { FaHeart, FaRegHeart, FaStar } from "react-icons/fa";
// import { FiMoreVertical } from "react-icons/fi";
// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";
// import EmptyStateCentered from "../static/EmptyStateCentered";
// import bg from "../../assets/membership.jpg";
// import mainbg from "../../assets/cardbg.jpeg";
// // import { getProfileSlug } from "..././api/slugify";
// const MatchesListPage = () => {
//   const [matches, setMatches] = useState([]);
//   const [favourites, setFavourites] = useState([]);
//   const [interestsSent, setInterestsSent] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeFilters, setActiveFilters] = useState({});
//   const [menuOpenId, setMenuOpenId] = useState(null);
//   const [loadingId, setLoadingId] = useState(null);
//   const user = JSON.parse(localStorage.getItem("user"));
//   const navigate = useNavigate();
//   const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

//   const fetchMatches = async (filters = {}) => {
//     try {
//       setLoading(true);
//       const res = await axios.get("api/matches/", { params: filters });
//       setMatches(res.data);
//       setLoading(false);
//     } catch (error) {
//       console.error(
//         "Error submitting company:",
//         error.response?.data || error.message
//       );
//       toast.error("Failed to add company");
//     }

//     setLoading(false);
//   };

//   const fetchFavourites = async () => {
//     try {
//       const res = await axios.get("/api/favourites/", {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });
//       setFavourites(res.data.map((fav) => fav.favourite_user));
//     } catch (error) {
//       console.error(error.response?.data || error.message);
//     }
//   };

//   const fetchInterestsSent = async () => {
//     try {
//       const res = await axios.get("/api/interests/sent/", {
//         // Adjust endpoint
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });
//       setInterestsSent(res.data.map((interest) => interest.receiver));
//     } catch (error) {
//       console.error(error.response?.data || error.message);
//     }
//   };

//   useEffect(() => {
//     fetchMatches();
//     fetchFavourites();
//     fetchInterestsSent();
//   }, []);

//   const sendInterest = async (receiverId) => {
//     setLoadingId(receiverId);
//     try {
//       await axios.post(
//         "/api/interests/",
//         { receiver: receiverId },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         }
//       );

//       toast.success("Interest sent!");

//       setMatches((prev) =>
//         prev.map((m) =>
//           m.user.id === receiverId ? { ...m, has_sent_interest: true } : m
//         )
//       );
//     } catch (error) {
//       toast.error("Failed to send interest");
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   const ignoreProfile = async (receiverId) => {
//     try {
//       await axios.post(
//         "/api/interests/",
//         { receiver: receiverId, status: "ignored" },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         }
//       );
//       toast.success("Profile ignored!");
//       setMatches((prev) => prev.filter((m) => m.user.id !== receiverId));
//     } catch (error) {
//       console.error(error.response?.data || error.message);
//       toast.error("Failed to ignore profile");
//     }
//   };

//   const toggleFavourite = async (receiverId) => {
//     try {
//       if (favourites.includes(receiverId)) {
//         await axios.delete(`/api/favourites/${receiverId}/`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         });
//         setFavourites((prev) => prev.filter((id) => id !== receiverId));
//         toast.success("Removed from favourites!");
//       } else {
//         await axios.post(
//           "/api/favourites/",
//           { favourite_user: receiverId },
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//             },
//           }
//         );
//         setFavourites((prev) => [...prev, receiverId]);
//         toast.success("Added to favourites!");
//       }
//     } catch (error) {
//       console.error(error.response?.data || error.message);
//       toast.error("Failed to update favourite status");
//     }
//   };

//   const handleBlockProfile = (receiverId) => {
//     confirmAlert({
//       title: "Confirm Block",
//       message:
//         "Are you sure you want to block this profile? You will not receive messages or see this profile again.",
//       buttons: [
//         {
//           label: "Yes, Block",
//           onClick: async () => {
//             try {
//               await axios.post(
//                 "/api/block-profile/",
//                 { blocked_id: receiverId },
//                 {
//                   headers: {
//                     Authorization: `Bearer ${localStorage.getItem(
//                       "accessToken"
//                     )}`,
//                   },
//                 }
//               );
//               toast.success("Profile blocked successfully.");
//               setMatches((prev) =>
//                 prev.filter((m) => m.user.id !== receiverId)
//               );
//             } catch (error) {
//               console.error(error.response?.data || error.message);
//               toast.error("Failed to block profile.");
//             }
//           },
//         },
//         {
//           label: "Cancel",
//           className: "bg-gray-200 text-gray-700",
//         },
//       ],
//       closeOnEscape: true,
//       closeOnClickOutside: true,
//       overlayClassName: "bg-black bg-opacity-50",
//     });
//   };

//   if (loading) {
//     return <GlobalLoader />;
//   }

//   return (
//     <div className="p-4 w-full mx-auto overflow-y-auto pt-16 sm:pt-16">
//       <FilterPillBar
//         activeFilters={activeFilters}
//         setActiveFilters={setActiveFilters}
//         onFilterChange={(filters) => fetchMatches(filters)}
//       />

//       {matches.length === 0 ? (
//         <EmptyStateCentered message="No matches available at the moment." />
//       ) : (
//         <div className="flex flex-col gap-4">
//           {matches.map((match) => {
//             const hasSentInterest = match.has_sent_interest;

//             return (
//               <div
//                 key={match.id}
//                 className="bg-white w-full rounded shadow p-4 flex flex-col sm:flex-row items-center sm:items-start gap-4 relative"
//                 style={{
//                   backgroundImage: `url(${bg})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                 }}
//               >
//                 <Link
//                   to={`/profile/${match.user.id}`}
//                   className="flex-shrink-0 relative"
//                 >
//                   {dayjs().diff(dayjs(match.created_at), "day") <= 30 && (
//                     <div className="absolute top-0 left-0 bg-pink-600 text-white text-xs font-semibold px-2 py-0.5 rounded shadow">
//                       NEW
//                     </div>
//                   )}
//                   <img
//                     src={
//                       match.photo || require("../../assets/default_image.webp")
//                     }
//                     alt={`${match.user.first_name}`}
//                     className="w-32 h-32 object-cover rounded"
//                   />
//                   <button
//                     onClick={(e) => {
//                       e.preventDefault();
//                       toggleFavourite(match.user.id);
//                     }}
//                     className="absolute top-2 right-2 bg-white p-1 rounded-full shadow hover:bg-gray-100"
//                   >
//                     {favourites.includes(match.user.id) ? (
//                       <FaHeart className="text-pink-600" />
//                     ) : (
//                       <FaRegHeart className="text-gray-500" />
//                     )}
//                   </button>
//                 </Link>
//                 <div className="absolute top-2 right-2">
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setMenuOpenId(
//                         menuOpenId === match.user.id ? null : match.user.id
//                       );
//                     }}
//                     className="p-1 hover:bg-gray-100 rounded-full"
//                   >
//                     <FiMoreVertical size={18} />
//                   </button>
//                   {menuOpenId === match.user.id && (
//                     <div className="absolute right-0 mt-2 w-40 bg-white border rounded shadow z-50">
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleBlockProfile(match.user.id);
//                           setMenuOpenId(null);
//                         }}
//                         className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
//                       >
//                         Block Profile
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <div className="flex-1">
//                   <Link
//                     to={`/profile/${match.user.id}`}
//                     className="flex-shrink-0 text-decoration-none"
//                   >
//                     <p className="font-semibold text-lg">
//                       {match.user.first_name} {match.user.last_name}
//                       {match.profile_completed && (
//                         <span
//                           className="ml-3 text-yellow-500"
//                           title="Profile 100% Completed"
//                         >
//                           <FaStar className="inline-block mb-1" />
//                         </span>
//                       )}
//                       {match.is_paid_member && (
//                         <span className="ml-2 px-2 py-1 text-xs bg-green-100 text-green-800 rounded">
//                           Paid Member
//                         </span>
//                       )}
//                     </p>
//                     <p className="text-sm text-gray-600 mb-2">
//                       {calculateAge(match.dob)} yrs • {match.height_feet} ft '
//                       {match.height_inches}" • {match.marital_status} •{" "}
//                       {match.highest_education} • {match.employed_in} •{" "}
//                       {match.work_location_city}
//                     </p>
//                   </Link>
//                   <div className="flex gap-2 mt-4">
//                     {!match.has_sent_interest ? (
//                       <>
//                         <button
//                           onClick={() => ignoreProfile(match.user.id)}
//                           className="border border-red-500 text-white-700 px-3 py-1 rounded hover:bg-gray-100 transition"
//                         >
//                           Don't Show
//                         </button>

//                         <button
//                           onClick={() => sendInterest(match.user.id)}
//                           disabled={loadingId === match.user.id}
//                           className="px-3 py-1 rounded bg-pink-600 text-white hover:bg-pink-700 transition flex items-center justify-center"
//                         >
//                           {loadingId === match.user.id ? (
//                             <span className="flex items-center gap-2">
//                               <svg
//                                 className="animate-spin h-4 w-4 text-white"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <circle
//                                   className="opacity-25"
//                                   cx="12"
//                                   cy="12"
//                                   r="10"
//                                   stroke="currentColor"
//                                   strokeWidth="4"
//                                 ></circle>
//                                 <path
//                                   className="opacity-75"
//                                   fill="currentColor"
//                                   d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//                                 ></path>
//                               </svg>
//                               Sending...
//                             </span>
//                           ) : (
//                             "Send Interest"
//                           )}
//                         </button>
//                       </>
//                     ) : (
//                       <button
//                         disabled
//                         className="px-3 py-1 rounded bg-gray-300 text-gray-600 cursor-not-allowed"
//                       >
//                         Interest Sent
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default MatchesListPage;

// src/components/MatchesListPage.jsx

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import GlobalLoader from "./GlobalLoader";
import FilterPillBar from "./FilterPillBar";
import { FaHeart, FaRegHeart, FaStar } from "react-icons/fa";
import { FiMoreVertical } from "react-icons/fi";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import EmptyStateCentered from "../static/EmptyStateCentered";

/* ─── CSS ─────────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');

.jbml {
  padding: clamp(12px, 2vw, 20px);
  width: 100%;
  padding-top: clamp(64px, 8vw, 80px);
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  background: linear-gradient(160deg, #ffffff 0%, #ffffff 55%, #ffffff 100%);
  position: relative;
}

/* dot-grid */
.jbml-dust {
  position: fixed; inset: 0; pointer-events: none; z-index: 0;
  background-image: radial-gradient(circle, rgba(201,150,42,0.08) 1px, transparent 1px);
  background-size: 36px 36px;
}

.jbml-inner { position: relative; z-index: 1; margin: 0 auto; }

/* ── Match card ── */
.jbml-card {
  background: linear-gradient(160deg, #2C0808 0%, #4A1010 100%);
  border: 1px solid rgba(201,150,42,0.2);
  border-radius: 16px;
  padding: clamp(14px, 2.5vw, 20px);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: clamp(14px, 2vw, 20px);
  position: relative;
  transition: border-color 0.2s, box-shadow 0.2s;
  margin-bottom: clamp(10px, 1.5vw, 14px);
  overflow: hidden;
}
.jbml-card::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 2px;
  background: linear-gradient(90deg, transparent, #C9962A, transparent);
}
.jbml-card:hover {
  border-color: rgba(201,150,42,0.45);
  box-shadow: 0 8px 32px rgba(0,0,0,0.4);
}


.jbml-avatar-link { flex-shrink: 0; position: relative; display: block; }

.jbml-avatar {
  width: clamp(96px, 12vw, 120px);
  height: clamp(96px, 12vw, 120px);
  object-fit: cover;
  border-radius: 12px;
  border: 2.5px solid #C9962A;
  box-shadow: 0 0 0 3px rgba(201,150,42,0.15);
  display: block;
}

/* NEW ribbon */
.jbml-new-badge {
  position: absolute; top: 0; left: 0;
  background: linear-gradient(90deg, #C9962A, #A87820);
  color: #2C1A0E;
  font-size: 9px; font-weight: 700;
  letter-spacing: 1px; text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 4px 0 4px 0;
}

/* Om badge on avatar */
.jbml-om-badge {
  position: absolute; bottom: -6px; right: -6px;
  width: 22px; height: 22px; border-radius: 50%;
  background: #C9962A;
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; color: #2C1A0E; font-family: serif;
  border: 2px solid #2C0808;
  box-shadow: 0 2px 6px rgba(0,0,0,0.4);
}

/* Fav heart button */
.jbml-fav-btn {
  position: absolute; top: 5px; right: 5px;
  width: 26px; height: 26px; border-radius: 50%;
  background: rgba(26,5,5,0.75);
  border: 1px solid rgba(201,150,42,0.3);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: background 0.18s;
}
.jbml-fav-btn:hover { background: rgba(201,150,42,0.2); }
.jbml-fav-btn svg  { font-size: 12px; }

/* ── Info block ── */
.jbml-info { flex: 1; min-width: 0; }

.jbml-name-row {
  display: flex; align-items: center; flex-wrap: wrap; gap: 8px;
  margin-bottom: 5px;
}
.jbml-name {
  font-family: 'Playfair Display', serif;
  font-size: clamp(15px, 1.8vw, 18px);
  font-weight: 700; color: #FDF6EC;
  text-decoration: none; line-height: 1.2;
}
.jbml-name:hover { color: #E8C46A; }

.jbml-star { color: #C9962A; font-size: 13px; }

.jbml-paid-badge {
  padding: 2px 8px;
  background: rgba(201,150,42,0.15);
  border: 1px solid rgba(201,150,42,0.35);
  border-radius: 10px;
  font-size: 10px; font-weight: 600;
  color: #C9962A; letter-spacing: 0.5px;
  text-transform: uppercase;
}

.jbml-details {
  font-size: clamp(11.5px, 1.2vw, 13px);
  color: rgba(253,246,236,0.60);
  line-height: 1.65;
  margin-bottom: clamp(10px, 1.5vw, 14px);
}
.jbml-details a { color: inherit; text-decoration: none; }
.jbml-details a:hover { color: #C9962A; }

/* ── Action buttons ── */
.jbml-actions { display: flex; gap: 8px; flex-wrap: wrap; }

.jbml-btn-ignore {
  padding: 7px clamp(12px, 1.8vw, 18px);
  background: transparent;
  border: 1.5px solid rgba(253,246,236,0.2);
  border-radius: 20px;
  color: rgba(253,246,236,0.55);
  font-size: clamp(11.5px, 1.2vw, 13px);
  font-weight: 500; cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: border-color 0.18s, color 0.18s;
}
.jbml-btn-ignore:hover {
  border-color: rgba(201,150,42,0.4);
  color: rgba(253,246,236,0.8);
}

.jbml-btn-interest {
  padding: 7px clamp(14px, 2vw, 22px);
  background: linear-gradient(90deg, #C9962A, #A87820);
  border: none; border-radius: 20px;
  color: #2C1A0E;
  font-size: clamp(11.5px, 1.2vw, 13px);
  font-weight: 700; cursor: pointer;
  font-family: 'Playfair Display', serif;
  display: flex; align-items: center; gap: 6px;
  transition: opacity 0.18s;
  white-space: nowrap;
}
.jbml-btn-interest:hover:not(:disabled) { opacity: 0.88; }
.jbml-btn-interest:disabled { opacity: 0.55; cursor: not-allowed; }

.jbml-btn-sent {
  padding: 7px clamp(12px, 1.8vw, 18px);
  background: rgba(201,150,42,0.08);
  border: 1.5px solid rgba(201,150,42,0.3);
  border-radius: 20px;
  color: rgba(201,150,42,0.6);
  font-size: clamp(11px, 1.1vw, 12.5px);
  font-weight: 600; cursor: not-allowed;
  font-family: 'Inter', sans-serif;
}

/* ── 3-dot menu ── */
.jbml-menu-wrap { position: absolute; top: 12px; right: 12px; }
.jbml-menu-btn {
  background: rgba(26,5,5,0.7);
  border: 1px solid rgba(201,150,42,0.25);
  border-radius: 50%; width: 28px; height: 28px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; color: rgba(253,246,236,0.6);
  transition: background 0.18s;
}
.jbml-menu-btn:hover { background: rgba(201,150,42,0.15); color: #C9962A; }

.jbml-dropdown {
  position: absolute; right: 0; top: 32px;
  background: #2C0808;
  border: 1px solid rgba(201,150,42,0.25);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.5);
  z-index: 50; min-width: 140px; overflow: hidden;
}
.jbml-dropdown button {
  display: block; width: 100%; text-align: left;
  padding: 10px 14px;
  font-size: 12.5px; color: rgba(253,246,236,0.75);
  background: none; border: none; cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: background 0.15s, color 0.15s;
}
.jbml-dropdown button:hover { background: rgba(201,150,42,0.1); color: #E8C46A; }

/* spin animation */
@keyframes jbmlSpin { to { transform: rotate(360deg); } }
.jbml-spin { animation: jbmlSpin 0.8s linear infinite; }

/* ── Responsive ── */
@media (max-width: 634px) {
.jbml {  padding-top: 0px;}
  .jbml-card { flex-direction: column; align-items: center; text-align: center; }
  .jbml-actions { justify-content: center; }
  .jbml-name-row { justify-content: center; }
  .jbml-menu-wrap { top: 10px; right: 10px; }
}
@media (max-width: 360px) {
  .jbml { padding-left: 10px; padding-right: 10px; }
}
`;

/* ─── Spinner ─────────────────────────────────────────────────────────────── */
const Spinner = () => (
  <svg
    className="jbml-spin"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
      opacity=".25"
    />
    <path
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      opacity=".75"
    />
  </svg>
);

/* ─── Component ───────────────────────────────────────────────────────────── */
const MatchesListPage = () => {
  const [matches, setMatches] = useState([]);
  const [favourites, setFavourites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilters, setActiveFilters] = useState({});
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [loadingId, setLoadingId] = useState(null);

  const navigate = useNavigate();
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

  /* inject CSS */
  useEffect(() => {
    const id = "jbml-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  /* close menu on outside click */
  useEffect(() => {
    const close = () => setMenuOpenId(null);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  const fetchMatches = async (filters = {}) => {
    try {
      setLoading(true);
      const res = await axios.get("api/matches/", { params: filters });
      setMatches(res.data);
    } catch {
      toast.error("Failed to fetch matches");
    } finally {
      setLoading(false);
    }
  };

  const fetchFavourites = async () => {
    try {
      const res = await axios.get("/api/favourites/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setFavourites(res.data.map((f) => f.favourite_user));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchMatches();
    fetchFavourites();
  }, []);

  /* ── Actions ── */
  const sendInterest = async (receiverId) => {
    setLoadingId(receiverId);
    try {
      await axios.post(
        "/api/interests/",
        { receiver: receiverId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );
      toast.success("🪷 Interest sent!");
      setMatches((prev) =>
        prev.map((m) =>
          m.user.id === receiverId ? { ...m, has_sent_interest: true } : m,
        ),
      );
    } catch {
      toast.error("Failed to send interest");
    } finally {
      setLoadingId(null);
    }
  };

  const ignoreProfile = async (receiverId) => {
    try {
      await axios.post(
        "/api/interests/",
        { receiver: receiverId, status: "ignored" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );
      toast.success("Profile hidden");
      setMatches((prev) => prev.filter((m) => m.user.id !== receiverId));
    } catch {
      toast.error("Failed to hide profile");
    }
  };

  const toggleFavourite = async (e, receiverId) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      if (favourites.includes(receiverId)) {
        await axios.delete(`/api/favourites/${receiverId}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        setFavourites((prev) => prev.filter((id) => id !== receiverId));
        toast.success("Removed from favourites");
      } else {
        await axios.post(
          "/api/favourites/",
          { favourite_user: receiverId },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          },
        );
        setFavourites((prev) => [...prev, receiverId]);
        toast.success("🪷 Added to favourites");
      }
    } catch {
      toast.error("Failed to update favourite");
    }
  };

  const handleBlockProfile = (receiverId) => {
    confirmAlert({
      title: "Block this profile?",
      message: "You will no longer see or receive messages from this profile.",
      buttons: [
        {
          label: "Yes, Block",
          onClick: async () => {
            try {
              await axios.post(
                "/api/block-profile/",
                { blocked_id: receiverId },
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                  },
                },
              );
              toast.success("Profile blocked");
              setMatches((prev) =>
                prev.filter((m) => m.user.id !== receiverId),
              );
            } catch {
              toast.error("Failed to block profile");
            }
          },
        },
        { label: "Cancel" },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    });
  };

  if (loading) return <GlobalLoader />;

  return (
    <>
      <div className="hidden md:block fixed top-12 md:left-64 right-0 z-20 bg-white">
        <div className="my-3 flex items-center justify-center px-4">
          <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
          <span className="mx-3 text-[#800000] tracking-wide drop-shadow-md text-sm tracking-wider text-mobile">
            JAIN VAR VADHU
          </span>
          <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
        </div>
      </div>
      <div className="jbml">
        <div className="jbml-dust" aria-hidden="true" />

        <div className="jbml-inner">
          <FilterPillBar
            activeFilters={activeFilters}
            setActiveFilters={setActiveFilters}
            onFilterChange={fetchMatches}
          />

          {matches.length === 0 ? (
            <EmptyStateCentered message="No sacred matches found at the moment." />
          ) : (
            <div role="list" aria-label="Match profiles">
              {matches.map((match) => {
                const isNew =
                  dayjs().diff(dayjs(match.created_at), "day") <= 30;
                const isFav = favourites.includes(match.user.id);
                const sentAlready = match.has_sent_interest;

                return (
                  <div key={match.id} className="jbml-card" role="listitem">
                    {/* ── Avatar ── */}
                    <Link
                      to={`/profile/${match.user.id}`}
                      className="jbml-avatar-link"
                    >
                      {isNew && (
                        <div className="jbml-new-badge" aria-label="New member">
                          NEW
                        </div>
                      )}

                      <img
                        src={
                          match.photo ||
                          require("../../assets/default_image.webp")
                        }
                        alt={match.user.first_name}
                        className="jbml-avatar"
                      />

                      {/* Om badge */}
                      <div className="jbml-om-badge" aria-hidden="true">
                        ꣽ
                      </div>

                      {/* Fav heart */}
                      <button
                        className="jbml-fav-btn"
                        onClick={(e) => toggleFavourite(e, match.user.id)}
                        aria-label={
                          isFav ? "Remove from favourites" : "Add to favourites"
                        }
                      >
                        {isFav ? (
                          <FaHeart style={{ color: "#C9962A", fontSize: 12 }} />
                        ) : (
                          <FaRegHeart
                            style={{
                              color: "rgba(253,246,236,0.5)",
                              fontSize: 12,
                            }}
                          />
                        )}
                      </button>
                    </Link>

                    {/* ── Info ── */}
                    <div className="jbml-info">
                      <div className="jbml-name-row">
                        <Link
                          to={`/profile/${match.user.id}`}
                          className="jbml-name"
                        >
                          {match.user.first_name} {match.user.last_name}
                        </Link>
                        {match.profile_completed && (
                          <FaStar
                            className="jbml-star"
                            title="Profile 100% complete"
                            aria-label="Complete profile"
                          />
                        )}
                        {match.is_paid_member && (
                          <span
                            className="jbml-paid-badge"
                            aria-label="Paid member"
                          >
                            Paid Member
                          </span>
                        )}
                      </div>

                      <p className="jbml-details">
                        {calculateAge(match.dob)} yrs
                        {match.height_feet
                          ? ` • ${match.height_feet}'${match.height_inches}"`
                          : ""}
                        {match.marital_status
                          ? ` • ${match.marital_status}`
                          : ""}
                        {match.highest_education
                          ? ` • ${match.highest_education}`
                          : ""}
                        {match.employed_in ? ` • ${match.employed_in}` : ""}
                        {match.work_location_city
                          ? ` • ${match.work_location_city}`
                          : ""}
                      </p>

                      <div className="jbml-actions">
                        {sentAlready ? (
                          <button
                            className="jbml-btn-sent"
                            disabled
                            aria-label="Interest already sent"
                          >
                            ✓ Interest Sent
                          </button>
                        ) : (
                          <>
                            <button
                              className="jbml-btn-ignore"
                              onClick={() => ignoreProfile(match.user.id)}
                              aria-label="Hide this profile"
                            >
                              Don't Show
                            </button>
                            <button
                              className="jbml-btn-interest"
                              onClick={() => sendInterest(match.user.id)}
                              disabled={loadingId === match.user.id}
                              aria-label={`Send interest to ${match.user.first_name}`}
                            >
                              {loadingId === match.user.id ? (
                                <>
                                  <Spinner /> Sending…
                                </>
                              ) : (
                                "🪷 Send Interest"
                              )}
                            </button>
                          </>
                        )}
                      </div>
                    </div>

                    {/* ── 3-dot menu ── */}
                    <div
                      className="jbml-menu-wrap"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        className="jbml-menu-btn"
                        onClick={() =>
                          setMenuOpenId(
                            menuOpenId === match.user.id ? null : match.user.id,
                          )
                        }
                        aria-label="More options"
                        aria-expanded={menuOpenId === match.user.id}
                      >
                        <FiMoreVertical size={14} />
                      </button>
                      {menuOpenId === match.user.id && (
                        <div className="jbml-dropdown" role="menu">
                          <button
                            role="menuitem"
                            onClick={() => {
                              handleBlockProfile(match.user.id);
                              setMenuOpenId(null);
                            }}
                          >
                            🚫 Block Profile
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MatchesListPage;
